const API_BASE = '/api/v1/smart-contracts';

export type ContractInfo = {
  address: string;
  contractName: string | null;
  isVerified: boolean;
  abi: unknown[] | null;
  compiler: string | null;
  license: string | null;
  proxy: boolean;
  implementation: string | null;
  sourceCode: string | null;
};

export type ContractInfoError = {
  msg: string;
  etherscanMessage?: string;
  status?: number;
  error?: string;
};

async function handleResponse<T>(res: Response): Promise<T> {
  const data = await res.json();
  if (!res.ok) {
    const err = (data as ContractInfoError)?.msg ?? res.statusText;
    throw new Error(err);
  }
  return data as T;
}

export async function getContractInfo(
  address: string,
  chainId: string = '1'
): Promise<ContractInfo> {
  const params = new URLSearchParams({
    address: address.trim(),
    chainId: chainId.trim(),
  });
  const res = await fetch(`${API_BASE}/info?${params}`);
  return handleResponse<ContractInfo>(res);
}
